import type { MouseEvent } from "react";
import googleMark from "../design/google-g.svg";

/**
 * "Continue with Google" (DESIGN.md §9, `auth-google`).
 *
 * A real link, not a button with a click handler: the API answers with a
 * redirect to Google, and only a navigation can follow one.
 */
export function GoogleButton({
  href,
  label = "Continue with Google",
  onClick,
}: {
  readonly href: string;
  readonly label?: string;
  /** Something to do before leaving, such as ending the current session. */
  readonly onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <a className="auth-google" href={href} onClick={onClick}>
      <img className="auth-google-mark" src={googleMark} alt="" />
      {label}
    </a>
  );
}
